var scope_0 = require('/opt/build/repo/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1b516ad79160b3fe8b220efb9d4f9307.js').default;
var scope_1 = require('/opt/build/repo/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3545e71494384b645b298c33950b8dac.js').default;
var scope_2 = require('/opt/build/repo/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3f03c6dd3b067dffeb52e7d565268086.js').default;
var scope_3 = require('/opt/build/repo/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4cc4f9f8b262b50a543488c6a6a8f61d.js').default;
var scope_4 = require('/opt/build/repo/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/549e60d093d440d82db671b310b8bf6d.js').default;
var scope_5 = require('/opt/build/repo/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/705fe6617f86ddd9c6bbc7e0af43926e.js').default;
var scope_6 = require('/opt/build/repo/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a6cf38a27e3c1ddb4f55f9981d1db00c.js').default;
var scope_7 = require('/opt/build/repo/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b9f54d6d429f6e26d5194072f0036171.js').default;
var scope_8 = require('/opt/build/repo/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ca28797624289caa60917149512cb314.js').default;
var scope_9 = require('/opt/build/repo/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e6df2bfc1b99a072224d5f574cbcf446.js').default;
var scope_10 = require('/opt/build/repo/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_11 = require('/opt/build/repo/research/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f37fc78df84b3653bbee9d7de676c516.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11 )
    